export enum ModulesEnum {
  ADMIN_PRODUCT = 'admin-product',
  ADMIN_DESKTOP = 'admin-desktop'
}
